export default __webpack_public_path__ + "static/media/excel-workbook.61a67547.svg";